<template>
  <div
    class="banner-ads"
  >
    <Adsense
      v-if="temScript(bannersArray)"
      :data-ad-client="`ca-pub-${googleAdsKeys[0]}`"
      :data-ad-slot="googleAdsKeys[1]"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />

    <v-carousel
      v-else
      :height="heightBanner"
      :style="`${widthBanner}; ${heightBanner}`"
      :show-arrows="setaBanner"
      :hide-delimiters="hideDelimiters"
      class="mx-auto rounded elevation-5"
      hide-delimiter-background
      next-icon="mdi-chevron-right"
      prev-icon="mdi-chevron-left"
      cycle
    >
      <v-carousel-item
        v-for="(banner, i) in bannersArray"
        :key="i"
        :alt="banner.alt_image"
        :href="banner.link"
        :src="imgBanner(banner)"
        target="_blank"
        @click.stop="contadorClick(banner.id)"
      />
    </v-carousel>
  </div>
</template>

<script>
import ApiBanners from '@/api/banners';

export default {
  name: 'BannersAds',

  props: {
    banners: {
      type: Array,
      required: true,
    },
    setaBanner: {
      type: Boolean,
      default: true,
    },
    widthBanner: {
      type: String,
      default: '',
    },
    heightBanner: {
      type: String,
      default: '',
    },
    hideDelimiters: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      bannersArray: [],
      clickErro: false,
      googleAdsKeys: [],
    };
  },

  created() {
    this.bannersArray = this.banners;
  },

  methods: {
    temScript(array) {
      if (array[0].script) {
        this.keysGoogle(array[0]);
        return true;
      }

      return false;
    },

    imgBanner(banner) {
      if (this.$vuetify.breakpoint.smAndUp) return banner.desktop_image_url;

      return banner.mobile_image_url;
    },

    keysGoogle(element) {
      const regex = /\s*;\s*/;
      this.googleAdsKeys = element.script.split(regex);
    },

    async contadorClick(idBanner) {
      const send = {
        id: idBanner,
      };

      await ApiBanners.bannersCountClick(send)
        .catch(() => {
          this.clickErro = true;
        });
    },
  },
};
</script>

<style lang="scss" scope>
.v-carousel__controls {
  height: 28px;

  &__item {
    color: transparent !important;
    margin: 0 !important;

    .v-icon {
      font-size: 13px !important;
      opacity: 1 !important;
      text-shadow: 0 0 2px #FFF;

      &:before { color: grey; }
    }

    &.v-item--active {
      .v-icon {
        &:before { color: var(--v-primary-base); }
      }
    }
  }
}
.banner-ads {
  .v-window__prev {
    .v-btn {
      color: var(--v-primary-base);
      background: rgba(255,255,255,0.48);
    }
  }
  .v-window__next {
    .v-btn {
      color: var(--v-primary-base);
      background: rgba(255,255,255,0.48);
    }
  }
}
</style>
